import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { PermissionService } from '@core/services/permission-service/permission-service'

export const createPermissionGuard = (
    permissionName: string,
    redirectTo: string | string[] = ['/'],
): CanActivateFn => {
    return async () => {
        const permissionService = inject(PermissionService)
        const router = inject(Router)

        // Ensure permissions are loaded (bitwise check)
        await permissionService.getPermissionsBitwise()

        const hasPermission =
            permissionService.canAccessPermissionOrImplicitFullAccess(permissionName)

        if (hasPermission) {
            return true
        }

        router.navigate(Array.isArray(redirectTo) ? redirectTo : [redirectTo])
        return false
    }
}
